import { axiosFunction } from "../../components/commonFunctions";
import { v2ReactURL } from "../constant";
import { getCommonIds, splitJoinedStrings } from "../FilterRelatedFunc";

 

export const handleApplyFilter = async (
  checkedValue: any,
  contactType: string,
  setContactFilteredIds: (ids: string[]) => void,
  setFilteringData: (data: any) => void,
  fetchData: (...args: any[]) => void,
  searchValue: string,
  pagination: { page: number },
  pageOption: string,
  viewAnalyticData: any,
  setOpenFilter: (value: null) => void,
  sessionBranchId: number ,
  callFilterselection = true,
          // New prop
) => {
  try {
    const contactIdsJson: Record<string, string[]> = {};

    const getCheckedValues = (field: string, key: string) =>
      Object.keys(checkedValue[field] || {}).map(
        (k) => checkedValue[field]?.[k]?.[key]
      ).filter(Boolean);

    for (const key in checkedValue) {
      const contactIds = Object.values(checkedValue[key] || {} as Record<string, { contactIds: string[] }>)
        .map((item) => (item as { contactIds: string[] }).contactIds)
        .filter(Boolean);

      if (contactIds.length > 0) {
        contactIdsJson[key] = contactIds.flat();
      }
    }

    const resArray = getCommonIds(splitJoinedStrings(contactIdsJson));
    setContactFilteredIds(resArray);

    const branchIdArray = getCheckedValues("location", "id") || [sessionBranchId];
    const memberShipArray = getCheckedValues("membershipName", "id");
    const contactTypeArray = getCheckedValues("contactType", "value");
    const gstTypeArray = getCheckedValues("gstType", "value");
    const customerSegment = getCheckedValues("totalSales", "value").toString() || "All";
    const usernameArray = getCheckedValues("createdByName", "userid");
    const cityArray = getCheckedValues("cityName", "city_id");
    const stateArray = getCheckedValues("stateName", "state_id");
    const countryArray = getCheckedValues("countryName", "country_id");
    const pincodeArray = getCheckedValues("pinCode", "pin_code");

    const statusStr = Object.keys(checkedValue["active"] || {})
      .map((key) => checkedValue["active"]?.[key]?.value)
      .join(", ");

    const mobNoStr = Object.keys(checkedValue["isMobNoVerify"] || {})
      .map((key) => checkedValue["isMobNoVerify"]?.[key]?.value)
      .join(", ");

      if (callFilterselection) {
    const resFiltered = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/filters/filterselection`,
      "POST",
      {
        branchIds: branchIdArray,
        membershipIds: memberShipArray,
        contactType: contactTypeArray,
        contactIds: resArray,
        createdByIds: usernameArray,
        cityIds: cityArray,
        stateIds: stateArray,
        countryIds: countryArray,
        pincodes: pincodeArray,
        status: statusStr,
        isMobNoVerify: mobNoStr,
        gstTypeArray : gstTypeArray,
        customerSegmentType: customerSegment,
      }
    );

    if (resFiltered?.data?.status) {
      setFilteringData(resFiltered?.data?.response);
    }
  }

    fetchData(
      searchValue,
      pagination.page * parseInt(pageOption),
      parseInt(pageOption),
      branchIdArray,
      memberShipArray,
      mobNoStr,
      viewAnalyticData,
      resArray,
      cityArray,
      stateArray,
      countryArray,
      pincodeArray,
      usernameArray,
      statusStr,
      contactTypeArray,
      gstTypeArray,
      customerSegment
    );

    setOpenFilter(null);
  } catch (error) {
    console.error("Error in handleApplyFilter:", error);
  }
};
